import { AgentOperatingModeEnum } from '@zaoblako/shared/modules/ai/enums/agent-operating-mode.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link AgentOperatingModeEnum} enumeration values */
export const AgentOperatingModeEnumI18n: EnumI18nInterface<AgentOperatingModeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [AgentOperatingModeEnum.FREE_MODE]: 'Свободный формат',
    [AgentOperatingModeEnum.FRM_MODE]: 'База знаний ФРМ',
  },
  [I18nLocalesEnum.EN_US]: {
    [AgentOperatingModeEnum.FREE_MODE]: 'Free format',
    [AgentOperatingModeEnum.FRM_MODE]: 'FRM knowledge base',
  },
};
